import React from 'react';
import {useFetchServicesProjetsQuery } from '../../services/auth-services/AuthService';
import { ProjectsEndpoints } from '../../Routes/api/Endpoints';
import ServiceCard from './ServiceCard';
import { Carousel } from "primereact/carousel";
import { responsiveOptions } from '../Utils/Variables/constantes';

const Partenaires = () => {
    const { data: servicesProjets, isLoading } = useFetchServicesProjetsQuery(
      ProjectsEndpoints.services
    );

    return (
      <div className="flex flex-col gap-3 md:gap-6 w-[90%] pt-12 pb-16 ps-5 pe-2">
        <h1 className="text-4xl font-bold text-center text-noirel max-sm:text-lg max-lg:text-xl mb-0">
          Services Disponibles
        </h1>
        <p className="font-mandali font-normal text-base leading-6 text-center text-gris">
          La plateforme Bakeli Work propose une variété de services digitaux
          pouvant être découpés
          <br className="block my-2" />
          en micro tâches
        </p>
        {servicesProjets &&
          <Carousel
            value={servicesProjets && servicesProjets}
            responsiveOptions={responsiveOptions}
            className="w-full !gap-6"
            color="#FAFEFC"
            numVisible={3}
            numScroll={3}
            itemTemplate={ServiceCard}
          />}

        {/* <div className="grid grid-cols-3 gap-8 max-lg:grid-cols-2 max-md:grid-cols-1 max-md:gap-2">
          {servicesProjets &&
            servicesProjets.map((service, index) => (
              <ServiceCard
                key={index}
                image={service?.image}
                name={service?.nom_service}
                sousServices={service?.sous_services}
              />
            ))}
        </div> */}
      </div>
    );
};

export default Partenaires;
